import { ThreeDots } from "react-loader-spinner";

import getCoreUIStore from "../../stores/core/core-ui-store";

import { TBadgeProps, TEt3Badge } from "../../Types";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import Et3Text from "../et3-text";
import ET3Div from "../et3-div";
import { CSSProperties } from "react";

const Badge = withLiteObserverAndTheme<TBadgeProps>((props) => {
  const { color, textColor, content, style, theme } = props;
  const { colors } = theme;
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={130}
      height={40}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={color}
      style={{
        alignSelf: "flex-end",
        borderRadius: 12,
        color: colors.all.white,
        ...style
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={100}
        height={30}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparent}
        style={{
          borderRadius: 12
        }}
        onClick={() => {}}
      >
        <Et3Text
          color={textColor}
          fontFamily={"MEDIUM"}
          fontSize={16}
          text={`${content}`}
          isSpan={true}
          style={{}}
        />
      </ET3Div>
    </ET3Div>
  );
});

const Et3Badge = withLiteObserverAndTheme<{
  type: TEt3Badge;
  content: string;
  style: CSSProperties;
}>((props) => {
  const { theme, type, content, style } = props;
  const { colors } = theme;
  const isLoading = getCoreUIStore().isLatestDataLoading.get();
  if (isLoading) {
    return <ThreeDots color={colors.all.deepSkyBlue} height={15} width={20} />;
  }
  switch (type) {
    case "APPROVE":
      return (
        <Badge
          textColor={colors.all.white}
          color={colors.all.blue}
          content={content}
          style={{}}
        />
      );
    case "REPORTS":
      return (
        <Badge
          textColor={colors.all.white}
          color={colors.all.red}
          content={content}
          style={{}}
        />
      );
    case "INVESTIGATION_CASES":
      return (
        <Badge
          textColor={colors.all.white}
          color={colors.all.red}
          content={content}
          style={{}}
        />
      );
    case "PAID":
      return (
        <Badge
          textColor={colors.all.white}
          color={colors.all.green}
          content={content}
          style={{}}
        />
      );
    case "NOT_PAID":
      return (
        <Badge
          textColor={colors.all.white}
          color={colors.all.red}
          content={content}
          style={{}}
        />
      );

    default:
      return (
        <Badge
          textColor={colors.all.darkOrange}
          color={colors.all.white}
          content={content}
          style={{ border: `1px solid ${colors.all.darkOrange}`, ...style }}
        />
      );
  }
});

export default Et3Badge;
